import AppDispatcher from '../dispatcher/AppDispatcher';
import Constants from '../constants/Constants';
import SuggestionsExtendedStore from '../stores/SuggestionsExtendedStore';

const { ActionTypes } = Constants;

module.exports = {
  submitForm() {
    const formData = new FormData();

    //
    formData.append('mainCategory', SuggestionsExtendedStore.getMainCategory());
    formData.append('subCategory', SuggestionsExtendedStore.getSubCategory());

    //
    const answers = SuggestionsExtendedStore.getFormData();
    Object.keys(answers).forEach((id) => formData.append(`answers[${id}]`, answers[id]));

    //
    const attachments = SuggestionsExtendedStore.getAttachments();
    Object.values(attachments).forEach((attachment) => formData.append('files[]', attachment));

    //
    formData.append('email', SuggestionsExtendedStore.getEmail());

    //
    fetch('/apiv1/suggestions/extended_form_submit', {
      method: 'post',
      credentials: 'include',
      body: formData,
    }).then((resp) => resp.json()).then((data) => {
      if (typeof data.status !== 'undefined' && data.status === 'ok') {
        AppDispatcher.dispatch({
          type: ActionTypes.SUGGESTIONS_EXTENDED_FORM_SUBMIT_SUCCESS,
        });
      } else {
        console.log(data);
        AppDispatcher.dispatch({
          type: ActionTypes.SUGGESTIONS_EXTENDED_FORM_SUBMIT_ERROR,
        });
      }
    }).catch((data) => {
      console.log(data);
      AppDispatcher.dispatch({
        type: ActionTypes.SUGGESTIONS_EXTENDED_FORM_SUBMIT_ERROR,
      });
    });
  },
};
